/**
 * Helper for marking an element `aria-busy` while a Promise is pending
 * @module lib/busy
 */

const SELECTOR_CONTROLS = `input, select, textarea`;

function setBusy(el) {
  el.setAttribute('aria-busy', 'true');
  // TODO: Investigate if there's better ways to prevent edition
  // or if even needed
  Array.from(el.querySelectorAll(SELECTOR_CONTROLS)).forEach(e =>
    e.setAttribute('disabled', '')
  );
}

function removeBusy(el) {
  el.removeAttribute('aria-busy');
  Array.from(el.querySelectorAll(SELECTOR_CONTROLS)).forEach(e =>
    e.removeAttribute('disabled')
  );
}

/**
 * Marks the given element with `aria-busy="true"` while the given promise
 * is pending. Also disables from controls within it and re-enables them
 * a
 * @param {HTMLElement} el
 * @param {Promise} promise
 */
export function busyWhile(el, promise) {
  setBusy(el);
  return promise.finally(() => removeBusy(el));
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/busy.js